import styled from '@emotion/styled'

export const FooterWrapper = styled.footer`
  align-content: flex-end;
  margin-top: auto;
`
